var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleMeet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_492_4513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5762 9.87324L15.9158 12.5475L19.062 14.5579L19.6093 9.89012L19.062 5.32764L15.8555 7.0937L13.5762 9.87324Z",
    fill: "#00832D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 14.1235V18.1011C0 19.0093 0.737212 19.7467 1.6456 19.7467H5.62321L6.44685 16.7413L5.62321 14.1235L2.89429 13.2998L9.37451e-05 14.1235H0Z",
    fill: "#0066DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.62321 0L0 5.62321L2.89447 6.44488L5.62321 5.62321L6.43185 3.041L5.62321 0Z",
    fill: "#E94235"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 14.1254H5.62311V5.62305H0V14.1254Z",
    fill: "#2684FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6547 2.38109L19.0625 5.32806V14.5582L22.6695 17.5166C23.2095 17.9396 23.9994 17.5541 23.9994 16.8677V3.01686C23.9994 2.32287 23.1907 1.93926 22.6546 2.38118",
    fill: "#00AC47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5762 9.87354V14.1238H5.62305V19.747H17.4166C18.3249 19.747 19.0621 19.0096 19.0621 18.1014V14.5582L13.5762 9.87354Z",
    fill: "#00AC47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4166 0H5.62305V5.62321H13.5762V9.87342L19.0622 5.32772V1.6457C19.0622 0.737305 18.3249 9.37451e-05 17.4166 9.37451e-05",
    fill: "#FFBA00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_492_4513"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 19.7802,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleMeet);
export default __webpack_public_path__ + "static/media/google-meet.1741dbd9ac198bd1ae9feaa974bf696f.svg";
export { ForwardRef as ReactComponent };